import { createSelector } from '@reduxjs/toolkit';
import { userProfileClientInfoSelector } from './userProfileClientInfoSelector';

export const userProfileClientInfoForAnalyticsSelector = createSelector([userProfileClientInfoSelector], clientInfo => {
  if (!clientInfo) {
    return null;
  }

  const { searchInfo, statistics, recentlyWatchedOffers } = clientInfo;

  return { searchInfo, statistics, recentlyWatchedOffers };
});
